import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getCachedEvent } from '~/helpers/token-helpers';
import { getEvent, logout } from '~/store/event';
import { useAppDispatch, useAppSelector } from './hooks';

export const useCheckEventLoaded = () => {
	const status = useAppSelector( (state: import('~/store').EventState) => state.event.status );
	const dispatch = useAppDispatch();
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const uris = location.pathname.split('/');
		const eventCode =  uris && uris.length > 1 && uris[2];

		// Sponsor-scan deep-links (/event/<code>/sponsor-scan/<sponsorId>) bootstrap themselves
		// via the link's `?t=` exchange token and don't rely on the ticket-scanner event cache.
		// Leave this hook a no-op for that path so it doesn't bounce to `/`.
		const isSponsorScanRoute = uris[3] === 'sponsor-scan';
		if (isSponsorScanRoute) {
			return;
		}

		if ( !eventCode ) {
			const errorMessage = location.pathname !== '/' ? 'Event nof found' : '';
			dispatch( logout( errorMessage ) );
			navigate('/');

		} else {
			const cachedEvent = getCachedEvent(eventCode);
			if ( cachedEvent ) {
				const { eventId, eventName, logoUrl, eventSlug } = cachedEvent;
				dispatch( getEvent({ eventId, eventName, logoUrl, eventSlug, eventAccessCode: eventCode }) );
			} else {
				dispatch( logout( '' ) );
				navigate('/');
			}
		}
	}, []);
	
	return status;
}
